<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.25 10.5C3.25 8.4375 4.91406 6.75 7 6.75H8.6875C8.99219 6.75 9.25 7.00781 9.25 7.3125C9.25 7.64062 8.99219 7.875 8.6875 7.875H7C5.54688 7.875 4.375 9.07031 4.375 10.5C4.375 11.9531 5.54688 13.125 7 13.125H8.6875C8.99219 13.125 9.25 13.3828 9.25 13.6875C9.25 14.0156 8.99219 14.25 8.6875 14.25H7C4.91406 14.25 3.25 12.5859 3.25 10.5ZM16.75 10.5C16.75 12.5859 15.0625 14.25 13 14.25H11.3125C10.9844 14.25 10.75 14.0156 10.75 13.6875C10.75 13.3828 10.9844 13.125 11.3125 13.125H13C14.4297 13.125 15.625 11.9531 15.625 10.5C15.625 9.07031 14.4297 7.875 13 7.875H11.3125C10.9844 7.875 10.75 7.64062 10.75 7.3125C10.75 7.00781 10.9844 6.75 11.3125 6.75H13C15.0625 6.75 16.75 8.4375 16.75 10.5ZM7.5625 9.9375H12.4375C12.7422 9.9375 13 10.1953 13 10.5C13 10.8281 12.7422 11.0625 12.4375 11.0625H7.5625C7.23438 11.0625 7 10.8281 7 10.5C7 10.1953 7.23438 9.9375 7.5625 9.9375Z"
      fill="currentColor"
    />
  </svg>
</template>
